module.exports = __webpack_public_path__ + "img/mscs.93aacb21.jpg";